import { PagamentoTipo } from 'common/genericTypes';
import { FileService } from 'services/fileService';

export interface LiquidacaoEmLoteExcelRow {
  tipo: PagamentoTipo;
  codigo: string;
  dataVencimento: string;
  liquidacaoDireta: boolean;
}

export interface LiquidacaoEmLoteApiRequest {
  instrumentos: Array<{
    codigo: string;
    tipo: string;
    dataVencimento: string;
  }>;
}

const TEMPLATE_HEADERS = ['Tipo', 'Codigo', 'Data Vencimento', 'Liquidação Direta'];

const parseTipo = (valor: string): PagamentoTipo => {
  const normalizado = valor.toUpperCase().trim();
  if (normalizado === 'JUROS') return PagamentoTipo.Juros;
  if (normalizado === 'AMORTIZAÇÃO' || normalizado === 'AMORTIZACAO') return PagamentoTipo.Amortizacao;
  throw new Error(`Tipo de evento inválido: "${valor}". Use JUROS ou AMORTIZAÇÃO.`);
};

const parseLiquidacaoDireta = (valor: string): boolean => {
  const normalizado = valor.toUpperCase().trim();
  return normalizado === 'SIM' || normalizado === 'S' || normalizado === 'TRUE';
};

export const parseLiquidacaoEmLoteExcel = async (file: File): Promise<LiquidacaoEmLoteExcelRow[]> => {
  const parsed = await FileService.parseFile(file, TEMPLATE_HEADERS);
  const rows: LiquidacaoEmLoteExcelRow[] = [];

  parsed.rows.forEach((row, index) => {
    const linhaNumero = index + 2;
    const tipo = row[0]?.trim();
    const codigo = row[1]?.trim();
    const dataVencimento = row[2]?.trim();
    const liquidacaoDireta = row[3]?.trim();

    if (!tipo || !codigo || !dataVencimento) {
      throw new Error(`Linha ${linhaNumero}: campos obrigatórios (Tipo, Codigo, Data Vencimento) não preenchidos.`);
    }

    rows.push({
      tipo: parseTipo(tipo),
      codigo,
      dataVencimento,
      liquidacaoDireta: parseLiquidacaoDireta(liquidacaoDireta || ''),
    });
  });

  if (rows.length === 0) {
    throw new Error('Planilha não contém dados. Preencha ao menos uma linha.');
  }

  return rows;
};

export const buildLiquidacaoEmLoteRequest = (rows: LiquidacaoEmLoteExcelRow[]): LiquidacaoEmLoteApiRequest => {
  const instrumentos = rows.map((row) => ({
    codigo: row.codigo,
    tipo: row.tipo,
    dataVencimento: row.dataVencimento,
  }));

  return { instrumentos };
};
